import { IconButton, Snackbar } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { memo } from "react";

import styles from "./Toast.module.scss";

type ToastProps = {
  readonly isVisible: boolean;
  readonly handleClose: () => void;
  readonly message: string;
};

export const Toast = memo<ToastProps>(({ isVisible, handleClose, message }) => (
  <Snackbar
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    classes={{
      anchorOriginBottomCenter: styles.toast,
    }}
    open={isVisible}
    autoHideDuration={5000}
    onClose={handleClose}
    message={message}
    action={
      <IconButton
        className={styles.button}
        edge="end"
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    }
  />
));
